import { getConfigExtraInfo } from "../helpers/utils";

export default function(app, live) {
  return function(chatbot) {
    chatbot.subscriptions.onStartConversation(function (conversationData, next) {
      const event = {
        event: "interacciones",
        page_path: window.location.pathname,
        evento_interactivo_accion:"clic",
        evento_interactivo_etiqueta:"chat"
      }
      window.dataLayer?.push(event);
      return next(conversationData);
    });
  }
}
